module.exports = __webpack_public_path__ + "img/license.1bb99804.jpg";